/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SaveDoctorExtraSpecialtiesRequest = {
  type: 'array',
  contains: {
    type: 'SaveDoctorExtraSpecialty',
  },
} as const;
